module.exports = __webpack_public_path__ + "static/media/NISM_Instructions.0516ca4e.pdf";